import httpClient from "./httpClient";

const base = "/group-configurations";

export function listAllGroupConfigurations() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function listGroupConfigurationsByClassId(classId) {
  return httpClient.get(`${base}/by-class/${classId}`).then((res) => res.data.data);
}

export function createGroupConfiguration(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function deleteGroupConfiguration(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}

export function updateGroupConfigurationSerial(payload) {
  return httpClient.post(`${base}/serial`, payload).then((res) => res.data);
}

export function updateApplicationFeesForOnlineAdmission(payload) {
  return httpClient.post(`${base}/online-admission-fees`, payload).then((res) => res.data);
}

export function classAdmissionSettingList() {
  return httpClient.get(`${base}/class-admission`).then((res) => res.data.data);
}

export function updateClassAdmissionSetting(payload) {
  return httpClient.post(`${base}/class-admission`, payload).then((res) => res.data);
}
